import { render, staticRenderFns } from "./CustomDocumentPreview.vue?vue&type=template&id=cabf1e48&scoped=true"
import script from "./CustomDocumentPreview.vue?vue&type=script&lang=js"
export * from "./CustomDocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./CustomDocumentPreview.vue?vue&type=style&index=0&id=cabf1e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabf1e48",
  null
  
)

export default component.exports